import { Api } from '../../services/http/Api';
import { throwIfGenericApiError } from '../GenericErrors';

export type PortfolioType = 'GERAL' | 'RESTRITO';

export type CompanySearchItem = {
  id: number;
  cnpj: string;
  empresa: string;
  portfolioType: PortfolioType;
  productsCount: number;
};

export type CompanyProductSetting = {
  sap_code: string;
  /** Produto oculto do portfólio desta empresa. */
  hidden: boolean;
  alternative_flow_id: number | null;
};

export type CompanySettings = {
  company: { id: number; cnpj: string; name: string };
  /** RESTRITO quando a empresa tem algum produto oculto. */
  portfolioType: PortfolioType;
  hiddenCount: number;
  products: CompanyProductSetting[];
};

export type CompanyProductPayload = {
  sap_code: string;
  hidden?: boolean;
  /** `null` volta a usar o fluxo principal do produto. */
  alternative_flow_id?: number | null;
};

class CompanyBasketsDatasource {
  async searchCompanies(search: string): Promise<CompanySearchItem[]> {
    const response = (await new Api().fetch(
      `basket/company-portfolio/companies?search=${encodeURIComponent(
        search.trim()
      )}&limit=20`
    )) as { data?: CompanySearchItem[] };
    throwIfGenericApiError(response);
    return Array.isArray(response?.data) ? response.data : [];
  }

  async getCompany(cnpj: string): Promise<CompanySettings> {
    const response = await new Api().fetch(`basket/company/${cnpj}`);
    throwIfGenericApiError(response);
    return response as CompanySettings;
  }

  async saveProduct(
    cnpj: string,
    payload: CompanyProductPayload
  ): Promise<CompanySettings> {
    const response = await new Api().post(
      `basket/company/${cnpj}/products`,
      payload
    );
    throwIfGenericApiError(response);
    return response as CompanySettings;
  }

  async resetPortfolio(cnpj: string): Promise<void> {
    const response = await new Api().delete(
      `basket/company-portfolio/companies/${cnpj}`
    );
    throwIfGenericApiError(response);
  }
}

export const CompanyBasketsDataSource = new CompanyBasketsDatasource();
